<template>
  <van-row justify="center" class="page-wrapper">
    <van-col span="24" class="flex-fix itserve-center round-shadow-btn cards-hint-wrap">
      <div class="cards-content-wrap">
        <template v-if="cards.length">
          <info-message>
            {{ $t("paymentCards.pushAtCard") }}
          </info-message>
        </template>
        <template v-else>
          <info-message>{{
            $t("paymentCards.listOfCardsEmpty")
          }}</info-message>
        </template>
      </div>
    </van-col>

    <van-col span="24" class="cards-list itserve-center">
      <div class="cards-stack">
        <template v-if="cards.length">
          <div
            v-for="card in normalizedCards"
            :key="card.id"
            class="cards-list-row"
          >
            <button
              type="button"
              class="cards-list-cell single-card"
              @click="deleteCard(card.id)"
            >
              <span class="card-brand-badge">
                <img
                  v-if="card.isVisa"
                  src="@/assets/images/visa.png"
                  class="card-type-image"
                />
                <img
                  v-else
                  src="@/assets/images/mastercard.png"
                  class="card-type-image"
                />
              </span>
              <span class="card-number-text">{{ card.masked }}</span>
            </button>
          </div>
        </template>
        <div class="add-card-button-wrap">
          <itserve-button
            type="primary"
            class="mt-15 add-card-button"
            :value="$t('buttons.addCard')"
            @click="goToPay"
          ></itserve-button>
        </div>
      </div>
    </van-col>
    <simple-dialog
      v-model="showDialog"
      :success="actionSuccessfully"
      :title="dialogMessage"
      @change="getCards"
    />
    <simple-dialog
      v-model="showDialog2"
      :success="actionSuccessfully"
      :title="dialogMessage"
    />
    <simple-dialog
      v-model="showDialog3"
      :success="actionSuccessfully"
      :title="dialogMessage"
    />
  </van-row>
</template>

<script>
import Dialog from "vant/lib/dialog/index";
import InfoMessage from "@/components/content/InfoMessage";
import SimpleDialog from "@/components/content/SimpleDialog";
import ItserveButton from "@/components/forms/ItserveButton";
import "vue-awesome/icons/plus";

export default {
  name: "PaymentCards",
  components: {
    ItserveButton,
    SimpleDialog,
    InfoMessage,
  },
  computed: {
    cards() {
      return this.$store.state.Payment.cards;
    },
    account() {
      return this.$store.state.Auth.account;
    },
    normalizedCards() {
      return this.cards.map((card) => {
        const masked = card.masked || card.pan || "";
        const brand = String(card.brand || "").toLowerCase();
        return {
          id: card.card_id || card.card_token,
          masked,
          isVisa: brand.includes("visa") || masked.trim().startsWith("4"),
        };
      });
    },
    addCardUrl() {
      return this.$store.state.Payment.addCardUrl;
    },
  },
  data() {
    return {
      showDialog: false,
      showDialog2: false,
      showDialog3: false,
      dialogMessage: "",
      actionSuccessfully: false,
    };
  },
  async created() {
    this.$store.dispatch("Payment/getCardsList");
  },
  methods: {
    async getCards() {
      await this.$store.dispatch("Payment/getCardsList");
    },
    goToPay() {
      this.$router.push({ name: "AddCard" });
    },
    deleteCard(token) {
      Dialog.confirm({
        title: this.$t("paymentCards.dialogDeleteMessage"),
        message: this.$t("paymentCards.dialogQuestion"),
        cancelButtonText: this.$t("paymentCards.dialogCancel"),
        confirmButtonText: this.$t("paymentCards.dialogConfirm"),
      })
        .then(async () => {
          let res = await this.$store.dispatch("Payment/deleteCard", token);
          if (Object.keys(res).indexOf("mode") >= 0) {
            if (res.mode === 1) {
              this.dialogMessage = this.$t("paymentCards.dialogSuccess");
              this.actionSuccessfully = true;
            } else {
              this.dialogMessage = this.$t("paymentCards.dialogError");
              this.actionSuccessfully = false;
            }
          } else {
            this.dialogMessage = this.$t("paymentCards.dialogError");
            this.actionSuccessfully = false;
          }
          this.showDialog = true;
        })
        .catch(() => {});
    },
    confirm() {
      if (this.dialogMessage !== this.$t("settings.error")) {
        location.reload();
      }
    },
  },
};
</script>

<style scoped>
@import "../../../node_modules/vant/lib/dialog/index.css";
@import "../../../node_modules/vant/lib/overlay/index.css";
@import "../../../node_modules/vant/lib/popup/index.css";

.cards-hint-wrap {
  padding: 0 12px;
}

.cards-list {
  padding: 16px 12px 0;
}

.cards-hint-wrap,
.cards-list {
  box-sizing: border-box;
}

.page-wrapper {
  --cards-shell-width: clamp(280px, 84vw, 430px);
  --cards-button-width: clamp(220px, 62vw, 320px);
}

.cards-content-wrap {
  width: 100%;
  max-width: var(--cards-shell-width);
  margin: 0 auto;
}

.cards-stack {
  width: 100%;
  max-width: var(--cards-shell-width);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.cards-list-row {
  width: 100%;
  max-width: var(--cards-shell-width);
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.cards-list-cell {
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  width: 100%;
  max-width: var(--cards-shell-width);
  min-height: 60px;
  margin: 0 auto;
  padding: 12px 18px;
  background: linear-gradient(180deg, #1a2333 0%, #141b28 100%) !important;
  border: 1px solid rgba(120, 148, 205, 0.24) !important;
  border-radius: 16px !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.03),
    0 10px 22px rgba(0, 0, 0, 0.16) !important;
  color: #fff !important;
  box-sizing: border-box;
  cursor: pointer;
  text-align: center;
}

.cards-list-cell:hover,
.cards-list-cell:focus,
.cards-list-cell:active {
  outline: none;
  border-color: rgba(120, 148, 205, 0.34) !important;
  transform: translateY(1px);
}

.card-brand-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 30px;
  padding: 4px 6px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: inset 0 0 0 1px rgba(18, 24, 35, 0.08);
  flex: 0 0 auto;
}

.card-number-text {
  display: inline-block;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.01em;
  text-align: left;
}

.cards-list :deep(.info-content) {
  display: inline-block;
  width: 100%;
  max-width: var(--cards-shell-width);
  margin: 0 auto;
  padding: 18px 20px;
  border-radius: 16px !important;
  background: #111620 !important;
  color: rgba(255, 255, 255, 0.92) !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 1.5;
  text-align: center !important;
  box-sizing: border-box;
}

.add-card-button-wrap {
  width: 100%;
  max-width: var(--cards-shell-width);
  margin: 4px auto 0;
  display: flex;
  justify-content: center;
}

.add-card-button {
  width: 100%;
}

.add-card-button :deep(.pushable) {
  width: 100%;
  max-width: var(--cards-shell-width) !important;
  margin: 0 auto;
  display: block !important;
}

.add-card-button :deep(.shadow),
.add-card-button :deep(.edge),
.add-card-button :deep(.front) {
  border-radius: 12px !important;
}

.add-card-button :deep(.btn-content) {
  height: 46px !important;
  line-height: 46px !important;
  font-size: 15px !important;
}

.card-type-image {
  display: block;
  width: 100%;
  max-width: 30px;
  height: auto;
}

.cards-hint-wrap :deep(.itserve-info-message) {
  width: 100%;
  display: flex;
  justify-content: center;
}

.cards-hint-wrap :deep(.info-content) {
  text-align: center !important;
}

@media (max-width: 767px) {
  .cards-hint-wrap,
  .cards-list {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 575px) {
  .page-wrapper {
    --cards-shell-width: min(100%, 360px);
    --cards-button-width: min(100%, 280px);
  }

  .cards-list {
    padding-top: 14px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .cards-stack {
    gap: 12px;
  }

  .cards-list-cell {
    max-width: 100% !important;
    min-height: 56px;
    gap: 10px;
    padding: 10px 14px !important;
    border-radius: 14px !important;
  }

  .card-brand-badge {
    width: 38px;
    height: 26px;
    border-radius: 7px;
  }

  .cards-list :deep(.info-content) {
    padding: 16px 14px;
    border-radius: 14px !important;
    font-size: 14px !important;
  }

  .card-type-image {
    max-width: 26px;
  }

  .card-number-text {
    font-size: 16px;
  }

  .add-card-button-wrap {
    margin-top: 10px;
  }

  .add-card-button :deep(.pushable) {
    max-width: 100% !important;
  }

  .add-card-button :deep(.btn-content) {
    height: 44px !important;
    line-height: 44px !important;
    font-size: 14px !important;
  }
}

@media (min-width: 768px) {
  .page-wrapper {
    --cards-shell-width: 430px;
    --cards-button-width: 300px;
  }

  .cards-hint-wrap,
  .cards-list {
    padding-left: 16px;
    padding-right: 16px;
  }

  .cards-list-cell {
    min-height: 62px;
    padding: 12px 18px !important;
  }

  .cards-list :deep(.info-content) {
    padding: 18px 22px;
  }
}
</style>
